module.exports = __webpack_public_path__ + "media/images/application/template/touch-gesture_01-46df6efddcb6072f582d0491a3e5102e.svg";